import * as React from "react"
import useScript from "./useScript"

export default function ActivecampaignModal() {
  useScript("https://life-coach-ranke.activehosted.com/f/embed.php?id=1")
  return (
    <>
      <div className="_form_1" />
    </>
  )
}
